// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import firebase from 'firebase'
import { store } from './store'
import VueAnalytics from 'vue-analytics'

// Vue.use(Vuetify)

Vue.use(Vuetify, {
  theme: {
    primary: '#3a81b7',
    secondary: '#232c3c',
    accent: '#007ddd',
    grayed: '7f7b82',
    whitened: 'f2f0eb',
    error: '#ed831a',
    cardgray: '#ebebeb'
  }
})

Vue.use(VueAnalytics, {
  // id: 'UA-92111602-3',  // Cambrio/dev
  id: 'UA-112467044-2',  // Kevin/DIUx
  router,
  autoTracking: {
    exception: true
  },
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'  // disable hit tracking in dev mode
  }
})

Vue.config.productionTip = false

let app  // for observer to init state via firebase auth

// // Initialize Firebase (dev config)
// let firebaseConfig = {
//   apiKey: 'AIzaSyBQGcnki3-koOuoErwRzEPvtRZEz7QRR9M',
//   authDomain: 'xview-dev.firebaseapp.com',
//   databaseURL: 'https://xview-dev.firebaseio.com',
//   projectId: 'xview-dev',
//   storageBucket: 'xview-dev.appspot.com',
//   messagingSenderId: '366210508116'
// }

// Initialize Firebase (production config)
let firebaseConfig = {
  apiKey: 'AIzaSyCepUbNY0jq6JMbh5j9fTQH8YJtRdoHwvo',
  authDomain: 'xview-91ca6.firebaseapp.com',
  databaseURL: 'https://xview-91ca6.firebaseio.com',
  projectId: 'xview-91ca6',
  storageBucket: 'xview-91ca6.appspot.com',
  messagingSenderId: '477231431572'
}

firebase.initializeApp(firebaseConfig)
firebase.auth().onAuthStateChanged(function (user) {
  if (!app) {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js